export default __webpack_public_path__ + "static/media/close.face4afe.svg";